import React from "react";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    logo: React.CSSProperties;
    note: React.CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    logo?: React.CSSProperties;
    note?: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    logo: true;
    note: true;
  }
}

export default {
  fontFamily: "Plus Jakarta Sans Variable, sans-serif",
  fontSize: 13,
  logo: {
    fontWeight: 800,
    fontSize: 27,
  },
  h1: {
    fontWeight: 800,
    fontSize: 20,
  },
  h3: {
    fontWeight: 600,
    fontSize: 36,
  },
  body1: {
    fontWeight: 400,
    fontSize: 14,
  },
  headline: {
    fontWeight: 500,
    fontSize: 16,
  },
  button: {
    fontWeight: 400,
    fontSize: 14,
  },
  note: {
    fontWeight: 400,
    fontSize: 12,
  },
};
